<template>
    <div :class="'video-container ' + cssClasses">
        <iframe
            title="Video player"
            width="100%" height="100%"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen="allowfullscreen"
            :data-src="src">
        </iframe>
      <div class="video-consent-overlay">
        <div class="video-consent-overlay-text">
          Votre vidéo n'est pas affichée car vous avez refusé les cookies.
        </div>
      </div>
    </div>
</template>

<script>
export default {
    name: "video-container",
    props: {
        src: {
            type: String,
            required: true
        },
        // cssClasses textuel optionnel qui vient surcharger la classe par defaut
        cssClasses: {
            type: String,
            required: false,
            default: null
        },
    },
}
</script>
